import axios from "axios";
import Constants from "./constant";
import moment from "moment";
import CryptoJS from "crypto-js";

export const axiosClient = axios.create({
    baseURL: `${Constants.env.lambdaApiServer}`,
});

// Request blocking mechanism for childreload
let isReloadInProgress = false;
let pendingRequests = [];
const RELOAD_ENDPOINT = "/parentapp/childLoginReloadDetails";

// Function to start blocking requests (called when reload starts)
export const startRequestBlocking = () => {
    console.log("[RequestBlocking] Starting request blocking for childreload");
    isReloadInProgress = true;
};

// Function to stop blocking requests (called when reload completes)
export const stopRequestBlocking = () => {
    console.log("[RequestBlocking] Stopping request blocking, processing pending requests");
    isReloadInProgress = false;

    // Process all pending requests
    const requestsToProcess = [...pendingRequests];
    pendingRequests = [];

    requestsToProcess.forEach(({ resolve, config }) => {
        console.log("[RequestBlocking] Processing pending request:", config.url);
        resolve(config);
    });
};

// Request interceptor to block requests during reload
axiosClient.interceptors.request.use(
    (config) => {
        // Allow the reload request itself to proceed
        if (config.url?.includes(RELOAD_ENDPOINT)) {
            console.log("[RequestBlocking] Allowing reload request:", config.url);
            return config;
        }

        // Block all other requests if reload is in progress
        if (isReloadInProgress) {
            console.log("[RequestBlocking] Blocking request during reload:", config.url);

            // Return a promise that will be resolved when reload completes
            return new Promise((resolve) => {
                pendingRequests.push({ resolve, config });
            });
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

let getCurrentDate = () => {
    return moment().utc().format("YYYY-MM-DD");
};
export const getAuthToken = (child_id = undefined, parent = undefined) => {
    const saltKey = "!foot@prints#education#";
    let token = getCurrentDate() + "_" + saltKey;
    console.log("Generating Token ...");

    if (child_id && parent) {
        token =
            child_id + "_" + getCurrentDate() + "_" + parent + "_" + saltKey;
    }
    // return crypto.createHash("md5").update(token).digest("hex");
    return CryptoJS.MD5(token).toString(CryptoJS.enc.Hex);
};

